// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__I97zN","content":"RecentSearches_content__3Dy4X"};